module.exports = __webpack_public_path__ + "static/media/huskar.a74518db.png";